<template>
    <div class="mt-5">
        <input v-model="tagFilter" class="form-control form-control-xs mb-4" type="text"
               placeholder="Filtrer les tags" :hidden="!isFilterable">
        <span v-for="tag in displayedTags.edges" :key="tag.node.id" class="d-inline-block mr-1 mb-2">
            <a class="btn btn-xs btn-soft-secondary" href="#">
                {{ tag.node.name }}
                <span v-if="isFilterable">({{ tag.node.usageCount }})</span>
            </a>
        </span>
    </div>
</template>

<script>
    export default {
        name: "TagsView",
        props: {
            tags: Object,
            isFilterable: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                tagFilter: ""
            }
        },
        computed: {
            displayedTags: function (){
                let filteredEdges;
                const tagFilter = this.tagFilter;

                filteredEdges = this.tags.edges.filter(function (edge) {
                    return edge.node.name.includes(tagFilter);
                });

                return {
                    edges: filteredEdges,
                    __typename: this.tags.__typename
                };
            }
        }
    }
</script>

<style scoped>

</style>